import 'babel-polyfill';
import Vue from 'vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import App from './App.vue'
import 'remixicon/fonts/remixicon.css';
import './assets/global.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(PerfectScrollbar);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
